import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Implementationrev() {
  return (
    <section className=" implementation_rev p-100 text_white bg_purple_color bg_circle_left">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto resp_order"
          >
            <h2>
              Technical
              <span style={{ color: "#E8E751" }}> Implementation</span>
            </h2>
            <div className="banner_img text-center">
              <StaticImage
                src="../../../images/case-studies/rev-coin/implement_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={800}
                height={462}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              The technical implementation of Rev Coin requires deploying it as
              an ERC20 token on the Ethereum blockchain, developing a robust and
              secure groundwork for transactions and ownership.
            </p>
            <p>
              A wide-ranging fund management system is created, employing base
              vault accounts to steadily store and manage funds.
            </p>
            <p>
              Account balances and transaction history are simply accessible
              through platforms like etherscan.io, warranting transparency and
              accountability.
            </p>
            <p>
              Employees can conveniently track their holdings and evaluate
              transaction details, promoting trust and confidence in the system.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Implementationrev;
